/**
 * /frontend/src/features/analytics/components/appointments/AppointmentOutcomePieChart.js
 */

import React from 'react';
import ChartContainer from '../shared/ChartContainer';
import DistributionPieChart from '../charts/DistributionPieChart';

/**
 * Appointment outcome distribution pie.
 * @param {{data:Array<{name:string,value:number}>}} props
 * @returns {JSX.Element}
 */
const AppointmentOutcomePieChart = ({ data }) => (
  <ChartContainer title="Appointment Outcomes" subtitle="Completed vs cancelled vs no-show">
    <DistributionPieChart data={data} nameKey="name" valueKey="value" />
  </ChartContainer>
);

export default AppointmentOutcomePieChart;

